// Deliberately NOT `client-only`: this is a pure read of NEXT_PUBLIC env
// and touches no browser API, so the marker would buy nothing and would
// break `instrumentation-client.test.ts`, which imports the entrypoint for
// real under node. `is-capturing.ts` keeps the marker — it touches the SDK.
import { env } from "@/lib/env";

/**
 * The dev-only escape hatch that loads posthog-js under `next dev`.
 *
 * Shared by `instrumentation-client.ts` (which decides whether to `init` at
 * all) and `is-capturing.ts` (which decides whether a capture UI may render), so
 * the two can never drift into disagreeing about what "forced" means — the
 * failure that drift would produce is a widget that renders locally and does
 * nothing, or one that refuses to render for the exact developer trying to
 * look at it.
 *
 * Guarded on NODE_ENV so it can NEVER turn on in a production or preview
 * build. Enable on demand: `env NEXT_PUBLIC_POSTHOG_FORCE=1 pnpm dev`.
 */
export const POSTHOG_DEV_FORCED =
  process.env.NODE_ENV !== "production" &&
  env.NEXT_PUBLIC_POSTHOG_FORCE === "1";
